import { Modal, Spin, Tooltip } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import ProjectForm from 'modules/Resume/DrawerComponents/ProjectDetails/ProjectForm'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import { StyledDiv } from 'modules/Dashboard/Style/style'
import { SpinWrapper } from 'modules/Onboarding/Register/Education/style'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'
import { searchAPI, setResumeData } from 'modules/Onboarding/actions'
import {
  AdjustIcon,
  FooterFlex,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import {
  ButtonLocal,
  Text,
} from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import { FlexWrapRole } from 'modules/Roles/Style/style'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { getStudentData } from '../../actions'
import instituteRequest from 'utils/instituteRequest'

const InternshipDrawerModal = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  listOfStudentSkills,
  getListOfSkills,
  setRoleDrawer,
  itemId,
  setLoading,
  roleDrawer = false,
  getEligibleDetails,
  getRoleFloatDetails,
  setExpDrawer,
  expDrawer,
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const [internship, setInternship] = useState([])
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)

  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }

      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI(0)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const approvedInternships = studentFormData?.resume?.internships || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields
    
    const addNewConfig = fields['internships.addNew']
    const shouldFreezeAddNew = (addNewConfig?.freezeAfterVerification || addNewConfig?.freezeAfterApproval) && approvedInternships.length >= 1
    setIsAddNewFrozen(shouldFreezeAddNew)

    approvedInternships.forEach((internship) => {
      if (!internship.id) return
      const internshipId = internship.id
      frozen[internshipId] = {}

      const fieldMappings = {
        'title': 'title',
        'organization': 'companyName',
        'started_in': 'started_in',
        'ended_in': 'ended_in',
        'description': 'description',
        'skill_set': 'skill_set',
        'certificate': 'certifications',
        'function': 'function',
        'role': 'role',
        'industry': 'industry',
        'awards': 'awards'
      }

      Object.entries(fieldMappings).forEach(([uiField, configFields]) => {
        const configFieldArray = Array.isArray(configFields) ? configFields : [configFields]
        
        const shouldFreeze = configFieldArray.some(configField => {
          const fullFieldName = `internships.${configField}`
          const fieldConfig = fields[fullFieldName]
          return fieldConfig && (fieldConfig.freezeAfterVerification || fieldConfig.freezeAfterApproval)
        })

        if (shouldFreeze) {
          const fieldValue = internship[uiField]
          
          if (uiField === 'certificate' || uiField === 'started_in' || uiField === 'ended_in') {
            frozen[internshipId][uiField] = true
          } else {
            const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                             (!Array.isArray(fieldValue) || fieldValue.length > 0)

            if (hasValue) {
              frozen[internshipId][uiField] = true
            }
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.internships])

  useEffect(() => {
    let internshipList = []
    
    const approvedInternships = studentFormData?.resume?.internships || []
    const pendingInternships = (pendingData && pendingData?.resume?.internships) || []
    
    const pendingMap = new Map()
    pendingInternships.forEach(p => {
      if (p.id && !p.id.startsWith('temp-')) {
        pendingMap.set(p.id, p)
      }
    })
    
    const mergedInternships = approvedInternships.map(approvedIntern => {
      const pendingIntern = pendingMap.get(approvedIntern.id)
      
      if (pendingIntern && pendingIntern._pendingFields) {
        const merged = { ...approvedIntern }
        
        Object.keys(pendingIntern._pendingFields).forEach(fieldName => {
          const value = pendingIntern._pendingFields[fieldName].value
          // Map companyName to organization for form compatibility
          if (fieldName === 'companyName') {
            merged.organization = value
          } else {
            merged[fieldName] = value
          }
        })
        
        merged._hasPendingChanges = true
        merged._pendingFields = pendingIntern._pendingFields
        
        return merged
      }
      
      return approvedIntern
    })
    
    const newPendingInternships = pendingInternships.filter(p => 
      p._isNew || (p.id && p.id.startsWith('temp-'))
    )
    
    const allInternships = [...mergedInternships, ...newPendingInternships]
    
    allInternships.map((data, index) => {
      let formName = 'internship_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          id: data?.id,
          temp_id: data?.temp_id,
          title: data?.title,
          corporateId: data?.corporateId,
          organization: data?.organization,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          industry: data?.industry,
          function: data?.function,
          role: data?.role,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate,
          awards: data?.awards,
          isDelete: false,
          shown: true,
        },
      })

      return internshipList.push({
        component: ProjectForm,
        formName: formName,
        pendingFields: data._pendingFields || {},
        frozenFields: frozenFieldsMap[data.id] || {},
        _requestId: data._requestId || null
      })
    })
    setInternship(internshipList)
  }, [studentFormData, pendingData, frozenFieldsMap])
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const internshipHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'internship_' + `${lastValue + 1}`

    arr.push({ 
        component: ProjectForm, 
        formName: formName,
      })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      return setInternship([...internship, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = internship?.filter(
        data => data?.formName !== deleteForm
      )
      return setInternship(updatedList)
    }
  }
  const submitHandler = async () => {
    let internship = []
    const values = await form.getFieldValue()

    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('internship') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          internship.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardInternData = []
      Object.entries(internship).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (name.includes('internship_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardInternData.push(load)
          }
        })
      })

      for (let i = 0; i < internship.length; i++) {
        for (const [key, value] of Object.entries(awardInternData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              internship[i].awards.push(value1)
            }
          }
        }
      }

      internship = internship.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))

      let payload = {
        refreshRanking: true,
        checkForApproval: true,
        checkDeleteSection: ['internships'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          internships: internship,
        },
      }

      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })
      payload?.resume?.internships.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete payload?.resume?.internships[index]?.certificate
        }
        delete payload?.resume?.internships[index]?.startMonth
        delete payload?.resume?.internships[index]?.startYear
        delete payload?.resume?.internships[index]?.endMonth
        delete payload?.resume?.internships[index]?.endYear
      })
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      if (payload?.studentPersonalProfile) {
        Object.keys(payload.studentPersonalProfile).forEach(key => {
          if (payload.studentPersonalProfile[key] === null) {
            delete payload.studentPersonalProfile[key]
          }
        })
      }
      if (payload?.currentCourse?.skills === null) {
        delete payload?.currentCourse?.skills
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      const response = await updateStudentData(payload)
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentData()).catch(err => console.error('getStudentData error:', err))
      if (getPendingData) {
        getPendingData().catch(err => console.error('getPendingData error:', err))
      }
      
      if (response?.success === true) {
        SuccessMessage('Internship sent for Approval!')
        setdrawerStatus(false)
        setUpdated(true)
        if (setExpDrawer) {
          setExpDrawer(true)
        }
        if (getEligibleDetails) {
          getEligibleDetails({ roleID: itemId, setLoading })
        }
        if (getRoleFloatDetails) {
          getRoleFloatDetails({ setLoading })
        }
        if (roleDrawer) {
          setRoleDrawer(true)
        }
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler && !updated}
          id={'internForm'}
          form={form}
          layout="vertical"
        >
          {!!internship?.length &&
            internship?.map((obj, index) => {
              return (
                <obj.component
                  key={index + 'internship'}
                  form={form}
                  onRemove={internshipHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfSkills}
                  getListOfSkills={getListOfSkills}
                  setCorporateName={setCorporateName}
                  corporateName={corporateName}
                  setCorporateId={setCorporateId}
                  corporateId={corporateId}
                  pendingFields={obj.pendingFields}
                  frozenFields={obj.frozenFields}
                  _requestId={obj._requestId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal 
          onClick={() => internshipHandler(true, false)}
          disabled={isAddNewFrozen}
          style={{ opacity: isAddNewFrozen ? 0.5 : 1, cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add internship</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.internships?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'internForm'}
          htmlType="submit"
          onClick={submitHandler}
          text={'Update'}
          disabled={isUpdateButtonEnabled}
        />
      </FooterFlex>
    )
  }
  return (
    <Modal
      visible={drawerStatus}
      onCancel={() => setdrawerStatus(false)}
      centered
      width="82%"
      footer={footer()}
      maskClosable={false}
      closable={false}
      destroyOnClose={true}
      bodyStyle={{
        padding: '0',
        borderRadius: '10px',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            padding: '15px 30px',
            overflowY: 'auto',
            alignSelf: 'stretch',
          }}
        >
          <FlexWrapRole spaceBetween>
            <div
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '25px',
                color: '#343E59',
              }}
            >
              {internship?.length === 0
                ? 'Add Internship'
                : 'Update Internship'}
            </div>
            <StyledDiv onClick={() => setdrawerStatus(false)}>
              <CrossIconSkill />
            </StyledDiv>
          </FlexWrapRole>
          {content()}
        </div>
      </div>
    </Modal>
  )
}
export default InternshipDrawerModal;
